


























































































































































































































import '@/extensions';
import {
    IErrors,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData, {ErrorsMap} from '@/mixins/local-data';

import {
    IModuleItemFilters,
    IModuleItemSaveDto,
} from '@/pages/ModuleItems/data';
import moment, { Moment } from 'moment';

import {BModal, BvModalEvent} from 'bootstrap-vue';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Card from '@/components/UI/Card.vue';
import DatePicker from 'vue2-datepicker';
import {isNumber} from "lodash";
import {TModuleType} from "@/pages/ModuleItems/data";

@Component({
    methods: {isNumber},
    components: {
        vSelect,
        Card,
        DatePicker
    },
})
export default class CreateItemModal extends Mixins(LocalData, Http) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: true}) readonly filters!: IModuleItemFilters;
    @Prop({required: true}) readonly disableCreateButton!: boolean;
    @Prop({required: true}) readonly errObj: any;

    @Watch('errObj', {deep: true})
    onErrObjChanged() {
        if (this.errObj) {
            this.handleHttpError(this.errObj);
        } else {
            this.hideFormErrors('saveItem');
        }
    }

    private confirmMessage = '';

    private itemParams: IModuleItemSaveDto = {
        id: null,
        startDate: new Date().toLocaleDateString('sv-SE'),
        endDate: new Date(((new Date()).setDate((new Date()).getDate() + 14))).toLocaleDateString('sv-SE'),
        name: null,
        type: null,
        stagesNumber: 3,
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minPromotionDiscount: null,
        maxPromotionDiscount: null,
        minMargin: null,
        revaluationFileName: null,
    };

    private formErrors: ErrorsMap = {};
    private showFormError: boolean = false;
    private ok_only = false;

    private get saveModal(): BModal {
        return this.$refs.saveItemModal as BModal
    }

    get minMarginValidate(): boolean {
        return !!((!this.itemParams.minMargin && this.itemParams.minMargin !== 0) || ((this.itemParams.minMargin || this.itemParams.minMargin == 0) && this.itemParams.minMargin >= -100 && this.itemParams.minMargin <= 100));
    }

    private createButtonClick() {
        this.saveModal.show();
    }

    private handleCancelClick () {
        this.saveModal.hide();

        this.itemParams = {
            id: null,
            startDate: new Date().toLocaleDateString('sv-SE'),
            endDate: new Date(((new Date()).setDate((new Date()).getDate() + 14))).toLocaleDateString('sv-SE'),
            name: null,
            type: null,
            stagesNumber: 3,
            minSaleDiscount: null,
            maxSaleDiscount: null,
            minPromotionDiscount: null,
            maxPromotionDiscount: null,
            minMargin: null,
            revaluationFileName: null,
        }
    }

    private onSaveButtonClicked(event: BvModalEvent) {
        event.preventDefault();

        if (Object.keys(this.itemParams).length) {
            const itemParams = Object.assign({}, this.itemParams);

            this.$emit('save-button-clicked', itemParams);
        }
    }

    private setNonNegative(input: string): string {
        const parsed = parseFloat(input);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return `${parsed * -1}`;
        } else {
            return input;
        }
    }

    valueInRange(input: string, fromNumber: number, toNumber: number): number {
        const inputValue = isNaN(parseFloat(input)) ? 0 : parseFloat(input);

        if (inputValue > toNumber) {
            return toNumber;
        } else if (inputValue < fromNumber) {
            return fromNumber;
        } else {
            return inputValue;
        }
    }

    handleMaxSaleDiscountValueChanged() {
        if (this.itemParams.minSaleDiscount && isNumber(this.itemParams.maxSaleDiscount)
            && this.itemParams.maxSaleDiscount < this.itemParams.minSaleDiscount) {
            this.itemParams.minSaleDiscount = this.itemParams.maxSaleDiscount;
        }
    }

    handleMaxPromotionDiscountValueChanged() {
        if (this.itemParams.minPromotionDiscount && isNumber(this.itemParams.maxPromotionDiscount)
            && this.itemParams.maxPromotionDiscount < this.itemParams.minPromotionDiscount) {
            this.itemParams.minPromotionDiscount = this.itemParams.maxPromotionDiscount;
        }
    }

    private getMessage(form: string, field: string): string | null {
        if (!this.formErrors.hasOwnProperty(form)) {
            return null;
        }

        if (!this.formErrors[form].hasOwnProperty(field)) {
            return null;
        }
        return this.formErrors[form][field].message;
    }

    private confirmHide() {
        this.confirmMessage = '';
    }

    private handleHttpError(err: any) {
        if (err && err.hasOwnProperty('response') && err.response != null) {
            if (err.response.data && err.response.data.errors && err.response.data.errors.length) {
                const errors = err.response.data as IErrors;
                this.renderErrors('saveItem', errors);
            } else if (err.response.data && typeof (err.response.data) === 'string') {
                this.showError(err.response.data);
                this.$log.error('Error occurred while save module item - ' + this.moduleType, err);
            } else {
                this.showError(this.$t('shared.parametersTab.errorSaveItemOnSave', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
                this.$log.error('Error occurred while save module item - ' + this.moduleType, err);
            }
        } else {
            this.showError(this.$t('shared.parametersTab.errorSaveItemOnSaveExcl', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
            this.$log.error('Error occurred while save module item - ' + this.moduleType, err);
        }
    }

    private renderErrors(form: string, errors: IErrors) {
        this.hideFormErrors(form)
        this.showFormError = true;
        errors.errors.forEach((e) => {
            this.formErrors[form][e.property] = e;
        });
    }

    private hideFormErrors(form: string) {
        this.formErrors[form] = {};
        this.showFormError = false;
    }

    private get allowToSave(): boolean {
        const minDiscountExists = this.moduleType === 'promo' ? (this.itemParams.minPromotionDiscount || this.itemParams.minPromotionDiscount === 0)
            : (this.itemParams.minSaleDiscount || this.itemParams.minSaleDiscount === 0);

        const maxDiscountExists = this.moduleType === 'promo' ? (this.itemParams.maxPromotionDiscount || this.itemParams.maxPromotionDiscount === 0)
            : (this.itemParams.maxSaleDiscount || this.itemParams.maxSaleDiscount === 0);

        return !!(this.itemParams.name && this.itemParams.type && this.itemParams.startDate && this.itemParams.endDate
            && this.minMarginValidate && (!!this.itemParams.minMargin || this.itemParams.minMargin === 0)
            && minDiscountExists && maxDiscountExists);
    }

    disabledDatepickerDate(current: Moment, data: any, property: string) {
        if (current && current < moment().startOf('day')) return true;

        if (property === 'startDate') {
            if (data.endDate) {
                return current && current > moment(data.endDate).endOf('day')
            }
        }

        if (property === 'endDate') {
            if (data.startDate) {
                return current && current < moment(data.startDate).startOf('day')
            }
        }

        return false;
    }
}
